import { render, staticRenderFns } from "./natural.vue?vue&type=template&id=37ba8775&"
import script from "./natural.vue?vue&type=script&lang=js&"
export * from "./natural.vue?vue&type=script&lang=js&"
import style0 from "./natural.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports